import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    term:'',
    startDate: '',
    endDate: '',
    loading: false,
}

const SetCurrentPeriod = () => {

    const [currentNotify, setNotify] = useState(null);
    const { getCurrentAcademicPeriod, academicTerms, getAcademicTerms} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        getAcademicTerms();
    }, [])

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(!state.term.value || state.startDate.length === 0 || state.endDate.length === 0){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.setCurrentPeriod(state.term.value, state.startDate, state.endDate);
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            dispatch({type: 'startDate', value: ''});
            dispatch({type: 'endDate', value: ''});
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getCurrentAcademicPeriod();
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


      const RenderTerms = () => {
        const options = [];
        if (Array.isArray(academicTerms) && academicTerms.length > 0) {
            academicTerms.map((item, key) =>
                options.push({ label: item.term, value: item.term_id })
            );
        }

        return (
            <TextInput
                label="Academic Term"
                type="select"
                leftIcon={true}
                placeholder={state.term.label || 'Select term....'}
                options={options}
                onChange={(item) => dispatch({ type: 'term', value: item })}
                leftComponent={<i className="fa fa-clock link" onClick={getAcademicTerms}></i>}
                loading={!academicTerms}
                wrap
            />
        );
    };


  

    return (
        <div className="card-body">

            <CallOut 
                title="Set Current Period"
                description="E.g. Term I 2025, Semester 1 2025, etc."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>


                        {RenderTerms()}

                        <TextInput
                            type="date"
                            label="Term Begins"
                            placeholder="Term Begins"
                            leftIcon="fa fa-calendar"
                            value={state.startDate}
                            onChange={e => dispatch({type: 'startDate', value: e.target.value})}
                            required
                            wrap
                            />
                        <TextInput
                            type="date"
                            label="Term Ends"
                            placeholder="Term Ends"
                            leftIcon="fa fa-calendar"
                            value={state.endDate}
                            onChange={e => dispatch({type: 'endDate', value: e.target.value})}
                            required
                            wrap
                            />
                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Confirm Period</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default SetCurrentPeriod;